import * as commonFields from "./common-fields";
import type { PmitImportDto } from "@ckweb/ckfetch/connectables/taskListManagement";

export const taskListSchema: $ck.z.ZodType<PmitImportDto> = $ck.z
  .object({
    isSubtask: commonFields.booleanField().transform((val) => val || false),
    taskDescription: commonFields.requiredStringField(),
    bilingualTaskDescription: commonFields.stringOrEmptyField(),
    forecastMinutes: commonFields.requiredNumberField().min(0).max(32768),
    showCompleted: commonFields.booleanField(),
    canPerformWhileRunning: commonFields.booleanField(),
    calculationMethod: commonFields.requiredStringListItemField(),
    skillLevel: commonFields.requiredStringListItemField(),
    priority: commonFields
      .requiredNumericListItemField()
      .min(1, "errors.itemNotFoundInList")
      .max(4, "errors.itemNotFoundInList"),
    controlPoint: commonFields.booleanField(),
    totalIntervalInWeeks: commonFields.requiredNumberField(),
    offsetWeeks: commonFields.requiredNumberField(),
    equipmentAreaId: commonFields.requiredNumericListItemField(
      "cksetup.imports.task-list.unknownEquipmentArea",
    ),
    item: commonFields.optionalNumberField(),
    item2: commonFields.stringOrEmptyField(),
  })
  .superRefine((data, ctx) => {
    if (data.offsetWeeks >= data.totalIntervalInWeeks) {
      ctx.addIssue({
        code: $ck.z.ZodIssueCode.custom,
        path: ["offsetWeeks"],
        message: "cksetup.imports.task-list.offsetWeeksMaxError",
      });
    }
  });

export type TaskListSchema = $ck.z.TypeOf<typeof taskListSchema>;
